import { useAgents, useWorkspaceRoot } from "@/lib/api";
import type { QueryClient } from "@tanstack/react-query";
import { parseRunId } from "./config-prefill";
export const agentConfigRouteOptions = {
	// Slack config-approval deep link: `?run_id=42` prefills the held builder
	// proposal for review. Coerce URL strings and drop non-numeric values.
	validateSearch: (search: Record<string, unknown>) => ({
		run_id: parseRunId(search.run_id),
	}),
	loader: ({
		context: { queryClient },
		params,
	}: {
		context: { queryClient: QueryClient };
		params: { owner: string };
	}) => {
		void queryClient.prefetchQuery(
			useWorkspaceRoot.queryOptions(params.owner, { slug: params.owner }),
		);
		void queryClient.prefetchQuery(useAgents.queryOptions(params.owner));
	},
};
